// extracted by mini-css-extract-plugin
export default {"root":"ChaptersList_root__KaErF"};